// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useMemo } from "react";
import { Autocomplete, Paper, Avatar } from "@mui/material";
import PropTypes from "prop-types";

import searchPink from "../../assets/images/search-pink.svg";
import { CustomChip } from "./CustomIconButton";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import "./AutoCompleteDropdown.css";
import { isUserRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";

// const Option = ({ option, onClick, props, hoveredPosition, setHoveredPosition }) => {
//   return (
//     <>
//       <div
//         // {...props}
//         style={{
//           position: 'relative',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'flex-start',
//           padding: '6px 8px',
//           boxSizing: 'border-box',
//           border: `1px solid rgb(209, 117, 182)`,
//           borderRadius: `4px`,
//           overflow: 'visible',
//           cursor: 'pointer'
//         }}
//         className={`autocomplete-option`}
//         onClick={onClick}
//       >
//         <div
//           style={{
//             width: '100%',
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             gap: '0.5rem'
//           }}
//         >
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '0.5rem'
//             }}
//           >
//             <p style={{
//               color: "white",
//               margin: '0'
//             }}>{option.label}</p>
//             {option?.tag?.length > 0 ? (
//               <FaStar
//                 color="rgb(209, 117, 182)"
//               />
//             ) : null}
//             <span
//               style={{
//                 color: "rgb(209, 117, 182)"
//               }}
//             >{option?.tag?.[0]}</span>
//           </div>

//           <div
//             onClick={e => {
//               e?.stopPropagation();
//               console.log('hovered');
//               if (!hoveredPosition || hoveredPosition?._id !== option?._id) {
//                 setHoveredPosition(option);
//               } else if (hoveredPosition?._id === option?._id) {
//                 setHoveredPosition(null);
//               }
//             }}
//             style={{
//               position: 'relative'
//             }}
//           >
//             {hoveredPosition?._id !== option?._id ? (
//               <FaInfoCircle
//                 color="white"
//                 style={{
//                   cursor: 'pointer'
//                 }}
//               />
//             ) : null}

//             {/* <IoMdArrowDropup
//               size={25}
//               style={{

//                 position: 'absolute',
//                 top: 'calc(100% - 10px)',
//                 left: '-5px',
//                 color: 'rgb(209, 117, 182)'

//               }}
//             /> */}

//             {hoveredPosition?._id === option?._id ? (
//               <>
//                 <CustomInfoButton
//                   header={option.label}
//                   body={option?.positionDescription}
//                   equipments={option?.tag}
//                 />
//               </>
//             )
//              : null
//             }
//           </div>
//         </div>
//         <div>
//           <p
//             style={{
//               margin: '0',
//               opacity: '0.5',
//               fontSize: '0.85rem',
//               color: "rgb(255, 255, 255, 0.75)"
//             }}
//           >{option?.positionBrief}</p>
//         </div>
//       </div>
//     </>
//   )
// };

function AutocompleteDropdown({
  options: positionOptions,
  handleChangeOption,
  setSearchTerm,
  searchTerm,
  placeholder,
  defaultId,
  value,
  isMultiple,
  style,
  Option,
  optionOnClick,
  onBlur,
}) {
  // Refs start...
  const inputRef = useRef(null);
  const rootContainer = useRef(null);
  // Refs end...

  // State variables start...
  const [hoveredPosition, setHoveredPosition] = useState(null);
  const [isInputFocused, setIsInputFocused] = useState(false);
  // State variables end...

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const options = useMemo(() => {
    if (
      !isUserRole(
        USER_ROLES.SUPERADMIN,
        USER_ROLES.ADMIN,
        USER_ROLES.COORDINATOR,
      )
    )
      return positionOptions?.filter((p) => !p?.isBackupPosition);
    else return positionOptions;
  }, [positionOptions]);

  // const defaultValue = options.find((option) => option.value === defaultId);

  React.useEffect(() => {
    if (!inputRef?.current) {
      return;
    }

    if (isInputFocused) {
      inputRef?.current?.focus?.();
    } else {
      inputRef?.current?.blur?.();
    }
  }, [isInputFocused]);

  // React.useEffect(() => {
  //   if (!inputRef?.current) {
  //     return;
  //   }

  //   console.log(inputRef?.current.getAttribute('placeholder').length, "placeholder-length")

  //   inputRef?.current.setAttribute('size', inputRef?.current.getAttribute('placeholder').length);
  // }, [value?.length]);

  return (
    <div
      style={{
        // height: "100%",
        // width: "100%",
        position: "relative",
        paddingLeft: "40px",
        border: `1px solid ${style?.borderColor || "#d175b6"}`,
        borderRadius: "8px",
      }}
      ref={rootContainer}
    >
      <img
        src={searchPink}
        alt=""
        style={{
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "10px",
          left: "10px",
        }}
      />
      <Autocomplete
        multiple={typeof isMultiple === "boolean" ? isMultiple : true}
        options={options}
        getOptionLabel={(option) => option.label || ""}
        isOptionEqualToValue={(option, value) => {
          return (
            value?.label === option?.label && value?.value === option?.value
          );
        }}
        // value={defaultValue || null}
        value={value || []}
        onBlur={onBlur || (() => {})}
        sx={
          {
            // width: "100%"
            // "& MuiAutocomplete-endAdornment css-p1olib-MuiAutocomplete-endAdornment MuiIconButton-root MuiSvgIcon-root": {
            //   color: 'white'
            // }
            // maxHeight: '10rem'
          }
        }
        renderTags={(value, getTagProps) => {
          return value?.map?.((option, index) => {
            if (!option) return;
            return (
              <React.Fragment key={option?._id}>
                <CustomChip
                  avatar={<Avatar>{option?.label?.[0]}</Avatar>}
                  sx={{
                    height: "32px",
                    borderRadius: "28px !important",
                  }}
                  label={option?.label}
                  {...getTagProps({ index })}
                  onDelete={() => {
                    handleChangeOption(option, null, "delete");
                    // dispatch(
                    //   removeCoordinatorAction(
                    //     {
                    //       eventId: state?.id,
                    //       coordinatorId: option?._id,
                    //     },
                    //     () => {
                    //       dispatch(
                    //         addLogAction({
                    //           id: state?.id,
                    //           paylaod: {
                    //             actionById: userId,
                    //             description: `Coordinator ${option?.fullName} removed from event.`,
                    //             userId: option?._id,
                    //           },
                    //         }),
                    //       );
                    //     },
                    //   ),
                    // )
                  }}
                />
              </React.Fragment>
            );
          });
        }}
        // renderInput={() => {}}
        renderInput={(params) => (
          <div
            style={{
              // padding: "0.35rem 0",
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={(e) => {
              setIsInputFocused(true);
            }}
            ref={params.InputProps.ref}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "0.5rem",
                width: "100%",
                minHeight: "48px",
                padding: "0.7rem 0",
                borderBottom: isInputFocused
                  ? `1px solid ${getCssVariableHandler({
                      variableName: "--font-rgb",
                    })}`
                  : "none",
                // marginTop: "0.5rem"
              }}
            >
              {value?.map?.((option, index) => {
                if (!option) return;
                return (
                  <React.Fragment key={option?._id}>
                    <CustomChip
                      avatar={<Avatar>{option?.label?.[0]}</Avatar>}
                      sx={{
                        height: "32px",
                        // height: "70%",
                        borderRadius: "28px !important",
                      }}
                      label={option?.label}
                      // {...getTagProps({ index })}
                      onDelete={() => {
                        handleChangeOption(option, null, "delete");
                        // dispatch(
                        //   removeCoordinatorAction(
                        //     {
                        //       eventId: state?.id,
                        //       coordinatorId: option?._id,
                        //     },
                        //     () => {
                        //       dispatch(
                        //         addLogAction({
                        //           id: state?.id,
                        //           paylaod: {
                        //             actionById: userId,
                        //             description: `Coordinator ${option?.fullName} removed from event.`,
                        //             userId: option?._id,
                        //           },
                        //         }),
                        //       );
                        //     },
                        //   ),
                        // )
                      }}
                    />
                  </React.Fragment>
                );
              })}

              <div
                style={{
                  // width: "100px",
                  flex: "1",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "32px",
                  gap: "0.5rem",
                }}
              >
                <input
                  {...params}
                  className={"autocompletedropdown-search"}
                  ref={inputRef}
                  label={"Type here to search position..."}
                  placeholder={placeholder || "Type here to search position..."}
                  value={searchTerm}
                  onChange={handleInputChange}
                  // variant="filled"

                  // focused={isInputFocused}
                  onFocus={(e) => {
                    setIsInputFocused(true);
                  }}
                  onKeyDown={(e) => {
                    if (searchTerm !== "") {
                      e?.stopPropagation();
                    }
                  }}
                  onBlur={(e) => {
                    setIsInputFocused(false);
                    setSearchTerm("");
                  }}
                  style={{
                    minWidth: "170px",
                    padding: "0 0.5rem",
                    border: "none",
                    borderBottom: "none",
                    outline: "none",
                    width: "100%",
                    background: "transparent",
                    color: "white",
                    minHeight: "3rem",
                    fontSize: "1rem",
                    fontFamily: "inherit",
                    "&:focus": {
                      border: "none",
                    },
                    "& input": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        // borderColor: "black",
                      },
                      "&:hover fieldset": {
                        // borderColor: "black",
                      },
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      "& .MuiButtonBase-root": {
                        "& .MuiSvgIcon-root": {
                          color: getCssVariableHandler({
                            variableName: `--font-rgb`,
                          }),
                        },
                      },
                    },
                  }}
                />
              </div>
            </div>

            {isInputFocused ? (
              options?.length > 0 ? (
                <div
                  style={{
                    width: `calc(100% + 40px)`,
                    maxHeight: "25rem",
                    overflowY: "scroll",
                    padding: "10px",
                    border: "1px solid rgb(209, 117, 182)",
                    borderRadius: "8px",
                    boxShadow: `7px 7px 20px rgba(209, 117, 182, 0.15), -7px 7px 20px rgba(209, 117, 182, 0.15)`,
                    position: "absolute",
                    top: "100%",
                    right: "0",
                    backgroundColor: "black",
                    zIndex: "2",
                  }}
                  className={"custom-scroll-design"}
                >
                  {options?.map((option) => {
                    return (
                      <React.Fragment key={option?._id}>
                        <Option
                          option={option}
                          setHoveredPosition={setHoveredPosition}
                          hoveredPosition={hoveredPosition}
                          onClick={(e) => {
                            e?.stopPropagation();
                            if (optionOnClick) {
                              optionOnClick(option, option?.label, "add");
                            }
                            // setIsInputFocused(false);
                            setSearchTerm("");
                            // handleChangeOption(option, option?.label, "add");
                          }}
                        />
                      </React.Fragment>
                    );
                  })}
                </div>
              ) : null
            ) : null}

            <svg
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              data-testid="ArrowDropDownIcon"
              style={{
                cursor: "pointer",
                color: `${getCssVariableHandler({
                  variableName: "--font-rgb",
                })}`,
                marginRight: "0.5rem",
                "-webkit-user-select": "none",
                "-moz-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                width: "1em",
                height: "1em",
                display: "inline-block",
                fill: "currentColor",
                "-webkit-flex-shrink": "0",
                "-ms-flex-negative": "0",
                flexShrink: "0",
                "-webkit-transition":
                  "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                fontSize: "1.7142857142857142rem",
              }}
              onClick={() => {
                setIsInputFocused(true);
              }}
            >
              <path d="M7 10l5 5 5-5z"></path>
            </svg>
          </div>
        )}
        onChange={(event, option) => {
          handleChangeOption(option, option?.label, "onChange");
        }}
        PaperComponent={(props) => {
          <Paper
            sx={{
              backgroundColor: "white",
            }}
            {...props}
          />;
        }}
        renderOption={(props, option) => (
          <Option
            props={props}
            option={option}
            setHoveredPosition={setHoveredPosition}
            hoveredPosition={hoveredPosition}
          />
        )}
      />
    </div>
  );
}

AutocompleteDropdown.propTypes = {
  options: PropTypes.array,
  handleChangeOption: PropTypes.func,
  setSearchTerm: PropTypes.func,
  searchTerm: PropTypes.string,
  defaultId: PropTypes.string,
  value: PropTypes.array,
  isMultiple: PropTypes.bool,
  Option: PropTypes.func,
  optionOnClick: PropTypes.func,
};

export default AutocompleteDropdown;